import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { UcaNavigationService } from '../../services/uca-navigation.service';
import { SubscriptionService } from '../../services/subscription.service';
import { AuthService } from '../../services/auth.service';
import { properties } from '../../../../environments/properties';
import { ParamService } from '../../services/param.service';

declare let $: any;
declare let window: any;


@Component({
  selector: 'uca-navigation',
  templateUrl: './uca-navigation.component.html',
  styleUrls: ['./uca-navigation.component.scss']
})
export class UcaNavigationComponent implements OnInit {
  currentRoute: string;
  currentEnvironment: string;
  userInfo: any;

  properties = properties;
  banner: string = '';

  enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
  programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

  menuItemClassNames: string[] = [];
  navItems: any = null;
  leftNavOptions: any = null;

  resizeTimeout: any;
  isMobileView: boolean = false;

  KEYCODE_TAB: number = 9;
  MOBILE_BREAKPOINT: number = 992;
  SELECTED_NAV: string = this.enableForUPlus ? 'Manage for U+' : 'Manage Freshpass';
  badgeText: string = 'Add';

  PROFILEOPTS: string = "fl=address,factors"
  primaryNavTitle: string = '';

  constructor(
    private ucaNavigationService: UcaNavigationService,
    private hostElement: ElementRef,
    public authService: AuthService,
    private paramService: ParamService,
    public subscriptionService: SubscriptionService) {
      this.primaryNavTitle = this.programDisplayData?.displayName.replace("{Banner}", this.paramService.capitalizedBanner);
  }

  ngOnInit() {
      this.currentEnvironment = this.subscriptionService.getEnvironment();

      this.subscriptionService.getUserInfoCall().subscribe((data: any) => {
        let isSessionValid = this.authService.isTokenValidForSession(data)
        if (isSessionValid) {
          const sessionData = { ...(data), authToken: data['SWY_SHOP_TOKEN'] };
          if (sessionData) {
            this.userInfo = sessionData;
            this.initSubscribes();
            this.checkViewportWidth();
            this.ucaNavigationService.getLeftNavItems();
            window.addEventListener('resize', this.throttledResize.bind(this));
          }
        }
      });
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.throttledResize.bind(this));
  }

  checkViewportWidth() {
    this.isMobileView = window.innerWidth < this.MOBILE_BREAKPOINT;
  }

  throttledResize() {
    if (!this.resizeTimeout) {
      this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = null;
        this.checkViewportWidth();
      }, 200);
    }
  }

  initSubscribes() {
   this.subscriptionService.getUserProfileInfo(this.userInfo, this.currentEnvironment, this.PROFILEOPTS).subscribe({
      next: (data) => {
        this.populateLeftNavItems(data);
      },
      error: (error) => {
        this.populateLeftNavItems();
      }
    });
  }

  populateLeftNavItems(data = null) {
    this.ucaNavigationService.populateUcaNavigationSource$.subscribe((value) => {
      if (value) {
          const leftMenuItems = value?.leftNavGroupCollection.map((leftMenuItem) => {
            const menuItems = leftMenuItem.menuItems.map((menuItem) => {
              const leftNavText = this.subscriptionService.replaceBannerPlaceholders(menuItem.leftNavText);
              let menuItemData = leftNavText.toLowerCase().startsWith('join') ?
                { ...menuItem, leftNavText, leftNavLink: `${menuItem.leftNavLink}`, isActive: true } :
                { ...menuItem, leftNavText, leftNavLink: `${menuItem.leftNavLink}`, isActive: false };

              if (leftNavText.toLowerCase().startsWith("join")) {
                menuItemData = {
                  ...menuItemData,
                  leftNavText: leftNavText.replace("Join", "Manage"),
                }
              }

              menuItemData = {
                ...menuItemData,
                eotFlagName: menuItem.eotFlagName ? menuItem.eotFlagName : '',
                ariaCurrent: menuItem.isActive ? 'page' : null,
                id: menuItem.id ? menuItem.id : null,
                tabindex: menuItem.tabIndex ? menuItem.tabIndex : null,
                role: menuItem.role ? menuItem.role : null,
                ariaLive: menuItem.ariaLive ? menuItem.ariaLive : null,
                ariaLevel: menuItem.ariaLevel ? menuItem.ariaLevel : null
              }

              const profileData = data;

              if (menuItem.leftNavText.toLowerCase() === "addresses") {
                menuItemData = {
                  ...menuItemData,
                  showAddLabel: profileData && !profileData?.addresses
                }
              }
              if (menuItem.leftNavText.toLowerCase() === "personal info") {
                let showAddLabel = profileData && profileData?.profileCompletionPercentage !== "100";
                if (profileData && profileData?.addresses) {
                  if (profileData?.profileCompletionPercentage === "100") {
                    showAddLabel = false
                  } else if (profileData?.profileCompletionPercentage !== "80") {
                    showAddLabel = true
                  }
                }
                menuItemData = {
                  ...menuItemData,
                  showAddLabel
                }
              }
              return menuItemData;
            });
            return {
              menuItems,
              groupTitle: this.subscriptionService.replaceBannerPlaceholders(leftMenuItem.groupTitle),
              groupIcon: leftMenuItem.groupIcon,
              id: leftMenuItem.id ? leftMenuItem.id : null,
              tabIndex: leftMenuItem.tabIndex ? leftMenuItem.tabIndex : null,
              role: leftMenuItem.role ? leftMenuItem.role : 'heading',
              ariaLive: leftMenuItem.ariaLive ? leftMenuItem.ariaLive : null,
              ariaLevel: leftMenuItem.ariaLevel ? leftMenuItem.ariaLevel : '3'

            };
          });
          const title = {
            text: this.subscriptionService.replaceBannerPlaceholders(value?.panelTitle),
            link: `${value?.panelLink}`,
            isActive: false
          }
          this.navItems = {
            leftMenuItems,
            title,
            selectedNav: '',
          }
      }
    });
  }

  handleKeyDown(event: KeyboardEvent): void {
    // Handle keydown events if needed
    // This method exists to satisfy SonarQube accessibility requirements
  }

  getMenuItemClassNames(className, isActive) {
    const baseClass = "navbar-hyperlink navbar-v2 ml-4 pl-2";
    this.menuItemClassNames = [baseClass];
    if (className) {
      this.menuItemClassNames.push(className);
    }
    if (isActive) {
      this.menuItemClassNames.push();
      this.menuItemClassNames.push('links__action__default', 'active')
    }
    return this.menuItemClassNames;
  }

  getBadgeClassNames(className: string): string[] {
    const baseClass = 'body-xs badge-info-uca d-inline-block mb0';
    return className ? [baseClass, className] : [baseClass];
  }

  getNavbarClass(className: string): string[] {
    const baseClass = 'dropdown-item dropdown-item-v2';
    return className ? [baseClass, className] : [baseClass];
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(e: KeyboardEvent): any {
    if (window.innerWidth <= 990) {
      if (e.key === 'Tab' || e.code === 'Tab') {
        let focusableEls = this.hostElement.nativeElement;
        let modalContent = $(focusableEls).find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), input[type="ul"]:not([disabled]), input[type="li"]:not([disabled])');
        let firstFocusableEl = modalContent.first()[0];
        let lastFocusableEl = modalContent.last()[0];

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      }
    }
  }

  getEOTFlag = (eotId = '') => {
    eotId = eotId.replace(/\D/g, "");
    let eotValue;
    // check if target set value available in window
    if ((window['analyticsSwy'] && window['analyticsSwy']['testFlags'] && window['analyticsSwy']['testFlags']['EOT' + eotId])) {
      eotValue = window['analyticsSwy']['testFlags']['EOT' + eotId];
    } else if ((window['analyticsSwy'] && window['analyticsSwy']['testFlags'] && window['analyticsSwy']['testFlags']['ACIP' + eotId])) {
      eotValue = window['analyticsSwy']['testFlags']['ACIP' + eotId];
    } else {
      eotValue = false
    }
    return eotValue;
  };

  onMouseOver(event: MouseEvent) {
    const element = event.target as HTMLElement;
    if (element) {
      element.classList.add('links__action__default');
    }
  }

  onMouseOut(event: MouseEvent) {
    const element = event.target as HTMLElement;
    if (element) {
      element.classList.remove('links__action__default');
    }
  }

}
